module.exports = __webpack_public_path__ + "static/media/day-icon.22272fae.svg";